// src/pages/Nosotros.js
import React, { useEffect, useState } from 'react';
import '../styles/nosotros.css';

const Nosotros = () => {
    const [contenido, setContenido] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let cancel = false;

        (async () => {
            try {
                const r = await fetch('/data/nosotros.json', { cache: 'no-store' });
                if (!r.ok) throw new Error('HTTP ' + r.status);
                const data = await r.json();
                if (!cancel) {
                    setContenido(data);
                    if (data?.seoTitle) document.title = data.seoTitle;
                }
            } catch (e) {
                console.error('[Nosotros] Error cargando /data/nosotros.json:', e);
                if (!cancel) {
                    setError(true);
                    // mantenemos contenido = null
                }
            } finally {
                if (!cancel) setCargando(false);
            }
        })();

        return () => {
            cancel = true;
        };
    }, []);

    // 1) Cargando: mientras aún no tenemos "contenido", no imprimimos texto para evitar hardcodear
    if (cargando || !contenido) {
        return (
            <div className="nosotros-wrapper" aria-busy="true" style={{ minHeight: 120 }} />
        );
    }

    // 2) Error de carga (ya con contenido presente para usar los textos de UI)
    if (error) {
        return (
            <div className="nosotros-wrapper">
                <p role="alert">{contenido.ui?.loadError}</p>
            </div>
        );
    }

    // 3) Caso sin contenido útil (defensivo)
    const sinContenido =
        !contenido.titulo &&
        !Array.isArray(contenido.mvvo) &&
        !contenido.historia?.titulo &&
        !contenido.historia?.parrafos;

    if (sinContenido) {
        return (
            <div className="nosotros-wrapper">
                <p>{contenido.ui?.empty}</p>
            </div>
        );
    }

    return (
        <div className="nosotros-wrapper">
            {/* Título principal */}
            <h1 className="titulo-nosotros">{contenido.titulo}</h1>
            <hr className="linea-separadora" />

            {/* Bloque Misión / Visión / Valores / Objetivos */}
            <div
                className="grid-mvvo"
                role="list"
                aria-label={contenido.titulo}
            >
                {contenido.mvvo?.map((item, idx) => (
                    <article className="mvvo-item" key={idx} role="listitem">
                        {item.icon && (
                            <img
                                src={item.icon}
                                alt={item.alt || contenido.ui?.iconAltDefault}
                                className="icono-mvvo"
                                loading="lazy"
                            />
                        )}
                        <h2>{item.titulo}</h2>
                        <p>{item.texto}</p>
                    </article>
                ))}
            </div>

            {/* Historia */}
            <section className="historia-bloque" aria-labelledby="historia-heading">
                <h2 id="historia-heading">{contenido.historia?.titulo}</h2>
                {Array.isArray(contenido.historia?.parrafos) ? (
                    contenido.historia.parrafos.map((p, i) => <p key={i}>{p}</p>)
                ) : (
                    contenido.historia?.parrafos && <p>{contenido.historia.parrafos}</p>
                )}
            </section>
        </div>
    );
};

export default Nosotros;
